import './PartnerSpecialDetailSwiper.scss';

import { array, func } from 'prop-types';
import React, { useMemo } from 'react';

import { Image, Text } from '@sitecore-jss/sitecore-jss-react';
import { IPAD_BREAKPOINT, SG_SITE_NAME } from '@utils/constant';
import { isAtSiteName } from '@utils/customsHook/useIsAtSiteName';
import { useWindowSize } from '@utils/customsHook/useWindowSize';

import SwipeComponent from '../../Share/SwipeComponent';

const PARTNER_PER_SLIDE_DESKTOP_VIEW = 12;
const PARTNER_PER_SLIDE_TABLET_VIEW = 6;
const PARTNER_PER_SLIDE_MOBILE_VIEW = 5;

const DESKTOP_BREAKPOINT = 1200;

const PartPartnerSpecialDetailsSwiper = ({
  partnerData,
  handleOpenModalPartner
}) => {
  const currentWindowSize = useWindowSize();
  const isAllowedNewUi = useMemo(() => isAtSiteName(SG_SITE_NAME), []);

  const mappingPartnerData = useMemo(() => {
    let mappedData = [];
    if (partnerData?.length) {
      const partnerDataPerSlide = currentWindowSize >= DESKTOP_BREAKPOINT
        ? PARTNER_PER_SLIDE_DESKTOP_VIEW
        : currentWindowSize
        >= IPAD_BREAKPOINT ? PARTNER_PER_SLIDE_TABLET_VIEW : PARTNER_PER_SLIDE_MOBILE_VIEW;
      const totalSlides = Math.ceil(partnerData.length / partnerDataPerSlide);

      (
        function splittingData (index) {
          if (index < totalSlides) {
            const startIndex = index * partnerDataPerSlide;
            const endIndex = startIndex + partnerDataPerSlide;

            mappedData[index] = [];
            for (let i = startIndex; i < endIndex; i++) {
              if (partnerData[i]) {
                mappedData[index].push(partnerData[i]);
              }
            }

            splittingData(index + 1);
          }
        }
      )(0);
    }

    return isAllowedNewUi ? mappedData : partnerData;
  }, [currentWindowSize, partnerData, isAllowedNewUi]);

  const swiperParams = useMemo(() => isAllowedNewUi ? {
    // loop: true,
    spaceBetween: 18,
    slidesPerView: 1,
    watchOverflow: true,
    shouldSwiperUpdate: true,
    pagination: mappingPartnerData.length > 1 ? {
      el: '.swiper-pagination',
      clickable: true
    } : {},
    breakpoints: {
      [IPAD_BREAKPOINT]: {
        spaceBetween: 30
      },
      [DESKTOP_BREAKPOINT]: {
        spaceBetween: 34
      }
    }
  } : {
    spaceBetween: 18,
    slidesPerView: 2.5,
    watchOverflow: true,
    shouldSwiperUpdate: true,
    breakpoints: {
      [IPAD_BREAKPOINT]: {
        slidesPerView: 3,
        spaceBetween: 30
      },
      [DESKTOP_BREAKPOINT]: {
        slidesPerView: partnerData.length >= 5 ? 5 : partnerData.length,
        spaceBetween: 34
      }
    }
  }, [isAllowedNewUi, mappingPartnerData]);

  return (
    <div
      className={[
        'partner-special__details-swiper', isAllowedNewUi ? 'slider-banners partner-special__details-swiper__v2' : ''
      ].join(' ')}
    >
      <SwipeComponent param={swiperParams}>
        {mappingPartnerData.map((slideData, index) => isAllowedNewUi ? (
          <div key={index} className='partner-special__details-swiper__slide'>
            {slideData?.length ? (
              slideData.map((item) => (
                <div
                  key={item?.Id}
                  className='partner-special__details-swiper__slide-box'
                  onClick={() => handleOpenModalPartner(item)}
                >
                  <div className='partner-logo'>
                    <div className='partner-logo__wrapper'>
                      <Image field={item?.['Partner Logo']} alt={item?.['Partner Name']} />
                    </div>
                  </div>
                  <Text tag='p' field={{ value: item?.['Partner Name'] }} className='partner-name' />
                </div>
              ))
            ) : (
              <></>
            )}
          </div>
        ) : (
          <div key={slideData?.Id} className='partner-special__details-swiper__item'>
            <div
              className='partner-logo'
              onClick={() => handleOpenModalPartner(slideData)}
            >
              <Image field={slideData?.['Partner Logo']} alt={slideData?.['Partner Name']} />
            </div>
            <Text tag='p' field={{ value: slideData?.['Partner Description'] }} className='description' />
          </div>
        ))}
      </SwipeComponent>
    </div>
  );
};

PartPartnerSpecialDetailsSwiper.propTypes = {
  partnerData: array,
  handleOpenModalPartner: func
};

export default PartPartnerSpecialDetailsSwiper;
